import {useState} from 'react';
import {toFloat} from "./formatting";
import useModalStore from "../stores/modalStore";

const sumYearValues = (obj) => {
    if (!obj || typeof obj !== "object") return toFloat(obj) || 0;
    return Object.values(obj).reduce((sum, val) => {
        if (typeof val === "number") return sum + val;
        if (typeof val === "object" && val !== null) return sum + sumYearValues(val);
        return sum + (toFloat(val) || 0);
    }, 0);
};

const toNumericValue = (value) => {
    if (value && typeof value === "object") {
        return sumYearValues(value);
    }
    return toFloat(value) || 0;
};

export function useTrendModalHelper() {
    const [trendData, setTrendData] = useState([]);
    const [trendTitle, setTrendTitle] = useState('');
    const [yKey, setYKey] = useState('');
    const [xKey, setXKey] = useState('');

    const openTrendModal = (label, xKey, yKey, accessorFn, historicPayrolls, options = {}) => {
        const { ytd = false, year = null } = options;
        const currentYear = year || new Date().getFullYear();

        const filteredPayrolls = historicPayrolls.filter(p => new Date(p.period_end).getFullYear() === currentYear);
        
        const data = ytd
            ? filteredPayrolls.map((payroll, index) => {
                    const ytdValue = filteredPayrolls
                        .slice(0, index + 1)
                        .reduce((sum, p) => sum + toNumericValue(accessorFn(p)), 0);
                    return {
                        [xKey]: payroll.period_end,
                        [yKey]: toFloat(ytdValue),
                    };
                })
            : historicPayrolls.map(payroll => ({
                [xKey]: payroll.period_end,
                [yKey]: toNumericValue(accessorFn(payroll)),
            }));

        setTrendTitle(label);
        setTrendData(data);
        setXKey(xKey);
        setYKey(yKey);
        useModalStore.getState().openModal("trendGraphModal");
    };


    return {
        trendData,
        trendTitle,
        xKey,
        yKey,
        openTrendModal //return the inner function when calling the outer function
    };
}

function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function computeYtdValue(payrolls, userId, key, currentRunEnd) {
    if (!payrolls || !key || !currentRunEnd) return 0;

    const currentYear = new Date(currentRunEnd).getFullYear();

    return payrolls
        .filter(p => new Date(p.period_end).getFullYear() === currentYear)
        .filter(p => new Date(p.period_end) <= new Date(currentRunEnd))
        .reduce((sum, p) => {
            if (userId) { //a specific employee
                const employee = p.employee_data.find(e => e.user_id === userId);
                const val = employee ? toNumericValue(getNestedValue(employee, key)) : 0;
                return sum + val;
            } else { //sum over all employees
                const periodSum = p.employee_data.reduce((empSum, e) => {
                    const val = toNumericValue(getNestedValue(e, key));
                    return empSum + val;
                }, 0);
                return sum + periodSum;
            }
        }, 0);
}

